/**
 * Dr. Mani's Magic Quiz — dosing rules.
 * Verbatim from dr-mm-files/dmm-quiz-spec.json -> dosing.
 *
 * CKAA is locked to the product label. Plant Super Boost and Super Soil are
 * marked "confirm" in the spec (see plan open item) — values below are the
 * spec's current best figures and may need sign-off before go-live.
 */
import type { Dosing } from './types';

export const DMM_DOSING: Dosing = {
  crab_kelp_amino_acids: {
    source: 'product label, confirmed',
    rules: {
      trees_and_outdoor_pots: '1 oz per inch of trunk diameter, monthly (skip temps under 40F)',
      indoor_plants: '1 tablespoon per inch of trunk diameter, monthly',
      lawns: '5 lb per 1,000 sq ft, 3 to 4 times per year in the growing season',
      gardens_beds_at_planting: '4 lb per 100 sq ft',
      gardens_beds_established: '1 lb per 100 sq ft monthly in the growing season',
    },
    conversions: {
      '1_lb': '16 oz',
      '2_lb_bag': '32 oz',
      '10_lb_bag': '160 oz',
      '1_tbsp': '~0.5 oz',
    },
    analysis: '7-4-4 NPK, Calcium 6%, Magnesium 2%, Sulfur 5%',
  },
  plant_super_boost: {
    source: 'internal notes, confirm',
    rules: {
      all_plants: 'about 2 oz per gallon of water, over the soil, monthly (weekly for faster results)',
      skip: 'freezing months',
    },
  },
  super_soil: {
    source: 'internal notes, confirm',
    rules: {
      sizing: 'one 10 lb bag fills a 5-gallon pot',
      refresh: 'once a year from the bottom',
    },
  },
};
